<template>
    <div id="vip-popover" :class="{ 'big-popover': lang !== 'zh', 'big-top-height': lang === 'de' }">
        <div class="top-bar">
            <img :src="require(`@/app/assets/img/vip-tip/vip-top-bg${lang !== 'zh' ? (lang === 'de' ? '3' : '2') : ''}.png`)" alt="" />
            <div class="content">
                <div class="content-title">
                    {{ $t("edrawmaxVip") }}
                    <img src="@/app/assets/img/vip-tip/vip-top-star.svg" alt="" />
                </div>
                <div class="content-desc">{{ $t("vipDesc") }}</div>
            </div>
        </div>
        <div class="benefit-title">
            {{ $t("benefitTitle", { benefitNum: benefits.length }) }}
        </div>
        <div class="benefit-list">
            <div class="benefit-item" v-for="(item, index) in benefits" :key="index">
                <img :src="require(`@/app/assets/img/vip-tip/${item.img}.svg`)" alt="" />
                <span>{{ $t(item.val) }}</span>
            </div>
        </div>
        <div class="btn-bar" :class="{ 'has-bubble': !!purchaseBubble }">
            <div class="vip-btn" @click="toVip">
                <div class="top-tip" ref="topTip" v-if="!!purchaseBubble">{{ purchaseBubble }}</div>
                <span>{{ $t("vip") }}</span>
            </div>
            <div class="show-more" @click="showMore" v-if="internal && lang == 'zh'">{{ $t("showMore") }}</div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class VipPopover extends Vue {
        get benefits() {
            const {
                vipSymbolMark,
                vipTemplateMark,
                cummunityVipTemplateMark,
                vipShapeNum,
                vipMath,
                vipPPTFont,
                vipPageTheme,
                vipPageColor,
                vipPageConnect,
                vipPageAutoBeautify,
                vipPageBackground,
                vipDoctWatermark,
                vipDocPageNum,
            } = this.$store.state.vipState;
            const marks = [];
            if (vipTemplateMark || cummunityVipTemplateMark) {
                marks.push({
                    val: "template",
                    img: "vip-benefit1",
                });
            }
            if (vipSymbolMark) {
                marks.push({
                    val: "symbol",
                    img: "vip-benefit2",
                });
            }
            if (vipShapeNum) {
                marks.push({
                    val: "shapeNum",
                    img: "vip-benefit3",
                });
            }
            if (vipPageTheme) {
                marks.push({
                    val: "pageTheme",
                    img: "vip-benefit4",
                });
            }
            if (vipPageColor) {
                marks.push({
                    val: "pageColor",
                    img: "vip-benefit5",
                });
            }
            if (vipPageConnect) {
                marks.push({
                    val: "pageConnect",
                    img: "vip-benefit6",
                });
            }
            if (vipPageAutoBeautify) {
                marks.push({
                    val: "autoBeautify",
                    img: "vip-benefit7",
                });
            }
            if (vipPageBackground) {
                marks.push({
                    val: "pageBackground",
                    img: "vip-benefit8",
                });
            }
            if (vipDoctWatermark) {
                marks.push({
                    val: "docWatermark",
                    img: "vip-benefit9",
                });
            }
            if (vipDocPageNum) {
                marks.push({
                    val: "docNum",
                    img: "vip-benefit10",
                });
            }
            if (vipMath) {
                marks.push({
                    val: "shapeMath",
                    img: "vip-benefit11",
                });
            }
            if (vipPPTFont) {
                marks.push({
                    val: "shapePPT",
                    img: "vip-benefit12",
                });
            }
            return marks;
        }

        get purchaseBubble() {
            return this.$store.state.publicStore.purchaseBubble;
        }

        toVip() {
            this.$openBuyPage("hoverNowFloatWindow");
            this.sensors.track("clickButtonInBuyNowFloatWindow", {
                Catalogues: "payPath",
                button_name: "buyNow",
            });
        }
        showMore() {
            this.$store.commit("toPublicStatus", {
                type: "upgradeTrigger",
                data: "vipBuyNowFloatWindow",
            });
            this.$store.commit("toPublicStatus", {
                type: "upgradeSuffix",
                data: "action=compare",
            });
            this.$store.commit("toPublicStatus", {
                type: "showBuyframe",
                data: true,
            });
            this.sensors.track("clickButtonInBuyNowFloatWindow", {
                Catalogues: "payPath",
                button_name: "learnMore",
            });
        }

        mounted() {}

        created() {}

        beforeDestroy() {}
    }
</script>

<style lang="stylus" scoped>
    #vip-popover
      width 360px
      background var(--bg-color-tertiary)
      box-shadow: $modal-shadow;
      border-radius 8px
      overflow hidden

      .top-bar
        position relative
        height 80px
        padding 18px
        img
          display block
          width 100%
          height 80px
          position absolute
          left 0
          top 0
          // z-index -1
        .content
          position relative
          z-index 10
          .content-title
            display flex
            font-size 16px
            font-weight 700
            line-height 20px
            color #FFDAAB
            margin-bottom 8px
            img
                position relative
                width 12px
                height 12px
                margin-left 4px
                margin-top -4px
          .content-desc
            font-size 11px
            color #FFE0B7

      .benefit-title
        margin 24px 24px 0
        font-size 14px
        color var(--text-color-primary)
      .benefit-list
            margin 16px 24px 24px
            display flex
            flex-wrap wrap
            row-gap 16px
            column-gap 16px
            .benefit-item
                display flex
                flex-direction column
                color var(--text-color-primary)
                font-size 12px
                justify-content flex-start
                align-items center
                flex-shrink 0
                width 66px
                min-height 56px
                word-break break-word
                text-align center
                img
                    margin-bottom 8px
      .btn-bar
            margin 24px
            &.has-bubble
              margin-top 32px
            .vip-btn
                  width 100%
                  height 32px
                  background linear-gradient(to right, #FFEF92, #FFD67B)
                  border-radius 6px
                  cursor pointer
                  font-size 12px
                  padding 8px 0
                  color #402300
                  text-align center
                  position relative
                  &:hover
                        background  #FFD67B
                  .top-tip
                    position absolute
                    bottom 26px
                    left 0
                    background linear-gradient(to left, #FF4848, #FF9C55)
                    border-radius  8px 8px 8px 0px
                    padding 4px 6px
                    color #fff
                    font-size 10px
                    height 20px
            .show-more
                  width 100%
                  text-align center
                  margin-top 16px
                  color var(--text-color-vip-popover-show-more)
                  cursor pointer
                  &:hover
                        color var(--text-color-vip-popover-show-more-hover)
    #vip-popover.big-popover
      width 360px
      .top-bar
        height 92px
        img
          height 92px
        .content
          .content-desc
            max-width 295px
    #vip-popover.big-top-height
      .top-bar
        height 110px
        img
          height 100%
</style>

<i18n>
{
  "zh": {
    "benefitTitle": "已使用{benefitNum}个特权",
    "vip": "开通VIP",
    "showMore": "了解更多",
    "template": "模板",
    "symbol": "符号",
    "shapeNum": "形状数",
    "pageTheme": "主题",
    "pageColor": "颜色",
    "pageConnect": "连接线",
    "autoBeautify": "一键美化",
    "pageBackground": "背景颜色",
    "docWatermark": "水印",
    "docNum": "页面",
    "shapeMath": "公式",
    "shapePPT": "文字",
    "edrawmaxVip": "尊享30+特权",
    "vipDesc": "此文件已使用会员特权，开通会员才能导出"
  },
  "en": {
    "vip": "Buy Now",
    "benefitTitle": "Used {benefitNum} benefit(s)",
    "showMore": "Learn More",
    "template": "Template",
    "symbol": "Symbol",
    "shapeNum": "Number of shapes",
    "pageTheme": "Theme",
    "pageColor": "Color",
    "pageConnect": "Connector",
    "autoBeautify": "One Click Beautifty",
    "pageBackground": "Background Color",
    "docWatermark": "Watermark",
    "docNum": "Pages",
    "shapeMath": "Formula",
    "shapePPT": "Text",
    "edrawmaxVip": "Enjoy 30+ benefits",
    "vipDesc": "Premium is required to export the file with benefits."
  },
  "fr": {
    "vip": "Acheter maintenant",
    "benefitTitle": "Avantages utilisés : {benefitNum}",
    "showMore": "En savoir plus",
    "template": "Modèles",
    "symbol": "Symboles",
    "shapeNum": "Nombre de formes",
    "pageTheme": "Thème",
    "pageColor": "Couleur",
    "pageConnect": "Ligne de connexion",
    "autoBeautify": "Formatage automatique",
    "pageBackground": "Couleur de fond",
    "docWatermark": "Filigrane",
    "docNum": "Page de Documentation",
    "shapeMath": "Officiel",
    "shapePPT": "Police",
    "edrawmaxVip": "Obtenez plus de 30 avantages",
    "vipDesc": "Pour exporter un fichier doté des avantages Premium, devenez d'abord membre Premium."
  },
  "de": {
    "vip": "Jetzt kaufen",
    "benefitTitle": "{benefitNum} Vorteile verwendet",
    "showMore": "Weitere Informationen",
    "template": "Vorlagen",
    "symbol": "Symbol",
    "shapeNum": "Anzahl an Formen",
    "pageTheme": "Thema",
    "pageColor": "Farbe",
    "pageConnect": "Verbindung",
    "autoBeautify": "Automatisch formatieren",
    "pageBackground": "Hintergrundsfarbe",
    "docWatermark": "Wasserzeichen",
    "docNum": "Seite",
    "shapeMath": "Formel",
    "shapePPT": "Font",
    "edrawmaxVip": "Profitieren Sie von über 30 Vorteilen",
    "vipDesc": "Um mit Premium-Vorteilen bearbeitete Dateien exportieren zu können, müssen Sie zuerst Premium-Mitglied werden."
  },
  "jp": {
    "vip": "今すぐ購入",
    "benefitTitle": "{benefitNum}種類の特典を使用",
    "showMore": "詳細を表示",
    "template": "テンプレート",
    "symbol": "記号",
    "shapeNum": "図形の個数",
    "pageTheme": "テーマ",
    "pageColor": "色",
    "pageConnect": "コネクター",
    "autoBeautify": "自動フォーマット",
    "pageBackground": "背景色",
    "docWatermark": "透かし",
    "docNum": "ページ",
    "shapeMath": "公式",
    "shapePPT": "フォント",
    "edrawmaxVip": "30種類以上の特典をご活用ください",
    "vipDesc": "プレミアム特典を含むファイルをエクスポートするには、プレミアムメンバーになる必要があります。"
  },
  "es": {
    "vip": "Comprar ahora",
    "benefitTitle": "{benefitNum} ventajas utilizadas",
    "showMore": "Más información",
    "template": "Plantillas",
    "symbol": "Símbolos",
    "shapeNum": "Número de formas",
    "pageTheme": "Tema",
    "pageColor": "Color",
    "pageConnect": "Conector",
    "autoBeautify": "Formateo automático",
    "pageBackground": "Color de Fondo",
    "docWatermark": "Marca de agua",
    "docNum": "Páginas",
    "shapeMath": "Fórmula",
    "shapePPT": "Font",
    "edrawmaxVip": "Disfruta de más de 30 ventajas",
    "vipDesc": "Para exportar las ventajas premium usadas, debes suscribirte primero a Premium."
  },
  "pt": {
    "vip": "Comprar agora",
    "benefitTitle": "Usou {benefitNum} benefício(s)",
    "showMore": "Saber mais",
    "template": "Modelos",
    "symbol": "Símbolos",
    "shapeNum": "Número de formas",
    "pageTheme": "Tema",
    "pageColor": "Cor",
    "pageConnect": "Conector",
    "autoBeautify": "Formatação Automática",
    "pageBackground": "Fundo",
    "docWatermark": "Marca de Água",
    "docNum": "Páginas",
    "shapeMath": "Fórmula",
    "shapePPT": "Fonte",
    "edrawmaxVip": "Aproveite mais de 30 benefícios",
    "vipDesc": "Para exportar os benefícios premium usados, você precisa se tornar premium primeiro."
  },
  "it": {
    "vip": "Acquista ora",
    "benefitTitle": "{benefitNum} vantaggi utilizzati",
    "showMore": "Ulteriori informazioni",
    "template": "Modelli",
    "symbol": "Simboli",
    "shapeNum": "Numero di forme",
    "pageTheme": "Tema",
    "pageColor": "Colore",
    "pageConnect": "Linea di collegamento",
    "autoBeautify": "Formattazione automatica",
    "pageBackground": "Sfondo",
    "docWatermark": "Filigrana",
    "docNum": "Pagine",
    "shapeMath": "Formula",
    "shapePPT": "Font",
    "edrawmaxVip": "Usufruisci di oltre 30 vantaggi",
    "vipDesc": "Diventa prima un utente Premium per esportare i vantaggi Pemium."
  },
  "tw": {
    "vip": "立即購買",
    "benefitTitle": "已使用 {benefitNum} 個權益",
    "showMore": "深入瞭解",
    "template": "模板",
    "symbol": "符號",
    "shapeNum": "形狀數量",
    "edrawmaxVip": "享用超過 30 個權益",
    "vipDesc": "若要匯出有使用 Premium 權益的檔案，您必須先成為 Premium 使用者。"
  },
  "kr": {
    "vip": "지금 구매하기",
    "benefitTitle": "혜택 {benefitNum}개를 사용함",
    "showMore": "자세히 알아보기",
    "template": "템플릿",
    "symbol": "심볼",
    "shapeNum": "形状数",
    "edrawmaxVip": "30가지 이상의 혜택을 누리세요.",
    "vipDesc": "프리미엄 혜택을 사용한 파일을 내보내려면 먼저 프리미엄에 가입해야 합니다."
  }
}
</i18n>
